module.exports = __webpack_public_path__ + "img/alert-verification.97bebdaa.svg";